// extracted by mini-css-extract-plugin
module.exports = {"hintText":"DraggerPanel_hintText__a85b4","draggerPanel":"DraggerPanel_draggerPanel__tG6gz","progressBarWrapper":"DraggerPanel_progressBarWrapper__mVwDm"};